import React, { useEffect } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import ContactForm from '@/components/contact/ContactForm';
import { Mail, MapPin, Instagram } from 'lucide-react';
import InteractiveMap from '@/components/contact/InteractiveMap';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation();
  const laPazCoordinates: [number, number] = [24.132169771800168, -110.30626523941062];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainLayout>
      <div className="pt-32 pb-24 bg-[#222222]">
        <div className="container-custom">
          <motion.h1
            className="section-title text-[#D9D9D9] mb-16"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {t('contact.title')}
          </motion.h1>

          <motion.div
            className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1, ease: 'easeOut' }}
          >
            <div>
              <p className="mb-8 text-[#CCCCCC]">{t('contact.intro')}</p>

              <div className="space-y-8 mb-12">
                <div className="flex items-start">
                  <MapPin size={24} className="mr-4 text-[#C8102E]" />
                  <div>
                    <h3 className="text-lg font-semibold text-[#D9D9D9] mb-1">{t('contact.addressTitle')}</h3>
                    <p className="text-[#BBBBBB]">
                      {t('contact.addressLine1')}<br />
                      {t('contact.addressLine2')}
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Mail size={24} className="mr-4 text-[#C8102E]" />
                  <div>
                    <h3 className="text-lg font-semibold text-[#D9D9D9] mb-1">{t('contact.emailTitle')}</h3>
                    <p className="text-[#BBBBBB]">mad73.arquitectos@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <Instagram size={24} className="mr-4 text-[#C8102E]" />
                  <div>
                    <h3 className="text-lg font-semibold text-[#D9D9D9] mb-1">{t('contact.instagramTitle')}</h3>
                    <a
                      href="https://www.instagram.com/mad73.arc"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#BBBBBB] underline decoration-transparent hover:text-[#C8102E] hover:decoration-[#C8102E] transition-colors duration-300 ease-out cursor-pointer"
                    >
                      @mad73.arc
                    </a>
                  </div>
                </div>
              </div>

              <p className="text-[#AAAAAA] mt-8">{t('contact.outro')}</p>
            </div>

            <motion.div
              className="bg-[#2A2A2A] p-8 rounded-lg border border-[#8f8f8f]/40 shadow-md"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: 'easeOut' }}
            >
              <h2 className="text-2xl font-poppins mb-6 text-[#F5F5F5] text-center">
                {t('contact.sendTitle')}
              </h2>
              <ContactForm />
            </motion.div>
          </motion.div>

          <motion.div
            className="w-full h-[400px] rounded-lg overflow-hidden shadow-lg"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <InteractiveMap
              position={laPazCoordinates}
              popupText={t('contact.mapPopup')}
              zoom={14}
            />
          </motion.div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Contact;
